function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var Notification = require('./notification');
var Tweets = require('./tweets');
function normalizeNotificationInput(mod, input) {
  if (!input) {
    return null;
  }
  if (input.msg && input.signature != null) {
    return Notification.fromTransaction(mod.app, mod, input);
  }
  return new Notification(mod.app, mod, input);
}
function getNotificationAggregateKey(mod, notification) {
  if (!notification || notification.type !== 'like') {
    return '';
  }
  if (!notification.actor_publicKey || !notification.tweet_signature) {
    return '';
  }
  return "like:".concat(notification.actor_publicKey, ":").concat(notification.tweet_signature);
}
function getUnreadNotificationCount(mod) {
  var _mod$moderate;
  var unread = mod.notifications_unread_count || 0;
  if (!mod.moderator_mode) {
    return unread;
  }
  var reviewCount = typeof ((_mod$moderate = mod.moderate) === null || _mod$moderate === void 0 ? void 0 : _mod$moderate.count) === 'function' ? mod.moderate.count() : 0;
  return unread + reviewCount;
}
function incrementUnreadNotifications(mod, notification) {
  if (!notification || notification.unread === false) {
    return;
  }
  mod.notifications_unread_count += 1;
}
function markNotificationsViewed(mod) {
  mod.notifications_unread_count = 0;
  mod.notifications_last_viewed_ts = Date.now();
  var _iterator = _createForOfIteratorHelper(mod.notifications_timeline),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var signature = _step.value;
      var notification = getNotification(mod, signature);
      if (notification) {
        notification.unread = false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  updateNotificationBadge(mod);
}
function updateNotificationBadge(mod) {
  var _mod$app$connection, _mod$main;
  var count = getUnreadNotificationCount(mod);
  (_mod$app$connection = mod.app.connection) === null || _mod$app$connection === void 0 || _mod$app$connection.emit('redsquare-update-notifications', count);
  if ((_mod$main = mod.main) !== null && _mod$main !== void 0 && _mod$main.menu) {
    mod.main.menu.updateBadge(count);
  }
}
function ensureNotificationTweet(mod, notification) {
  if (!(notification !== null && notification !== void 0 && notification.tx)) {
    return;
  }
  var txmsg = returnMessage(notification.tx);
  if (txmsg.request !== 'create tweet') {
    return;
  }
  if (!Tweets.hasTweet(mod, notification.signature)) {
    Tweets.addTweet(mod, notification.tx);
  }
}
function returnMessage(tx) {
  if (tx && typeof tx.returnMessage === 'function') {
    return tx.returnMessage();
  }
  return tx && tx.msg && _typeof(tx.msg) === 'object' ? tx.msg : {};
}
function isKeyringContact(mod, publicKey) {
  var _mod$app, _mod$app$returnKeys;
  if (!publicKey || publicKey === mod.publicKey) {
    return false;
  }
  var keys = ((_mod$app = mod.app) === null || _mod$app === void 0 || (_mod$app = _mod$app.keychain) === null || _mod$app === void 0 || (_mod$app$returnKeys = _mod$app.returnKeys) === null || _mod$app$returnKeys === void 0 ? void 0 : _mod$app$returnKeys.call(_mod$app)) || [];
  return keys.some(function (key) {
    return (key === null || key === void 0 ? void 0 : key.publicKey) === publicKey;
  });
}
function getInteractionTargetPublicKey(notification) {
  var tx = notification === null || notification === void 0 ? void 0 : notification.tx;
  var actorPublicKey = (notification === null || notification === void 0 ? void 0 : notification.actor_publicKey) || '';
  if (!tx || !Array.isArray(tx.to)) {
    return '';
  }

  // Wallet transactions include a sender output, so ownership comes from the
  // first recipient other than the actor rather than tx.to[0].
  var target = tx.to.find(function (slip) {
    return (slip === null || slip === void 0 ? void 0 : slip.publicKey) && slip.publicKey !== actorPublicKey;
  });
  return (target === null || target === void 0 ? void 0 : target.publicKey) || '';
}
function isOwnTweetInteraction(mod, notification) {
  var tweet = Tweets.getTweet(mod, notification === null || notification === void 0 ? void 0 : notification.tweet_signature);
  if (tweet !== null && tweet !== void 0 && tweet.publicKey) {
    return tweet.publicKey === mod.publicKey && notification.actor_publicKey !== mod.publicKey;
  }
  return notification.actor_publicKey !== mod.publicKey && getInteractionTargetPublicKey(notification) === mod.publicKey;
}
function isReplyToOwnTweet(mod, notification) {
  var data = returnMessage(notification === null || notification === void 0 ? void 0 : notification.tx).data || {};
  var parentSignature = data.parent_id != null ? String(data.parent_id) : '';
  var parent = Tweets.getTweet(mod, parentSignature);
  if (!parentSignature) {
    return false;
  }
  if (parent !== null && parent !== void 0 && parent.publicKey) {
    return parent.publicKey === mod.publicKey;
  }
  return getInteractionTargetPublicKey(notification) === mod.publicKey;
}
function shouldNotify(mod, notification) {
  var _Tweets$getTweet;
  if ((_Tweets$getTweet = Tweets.getTweet(mod, notification === null || notification === void 0 ? void 0 : notification.tweet_signature)) !== null && _Tweets$getTweet !== void 0 && _Tweets$getTweet.ephemeral) {
    return true;
  }
  if (!(notification !== null && notification !== void 0 && notification.actor_publicKey) || notification.actor_publicKey === mod.publicKey) {
    return false;
  }
  var request = returnMessage(notification.tx).request;
  if (request === 'create tweet' || notification.type === 'tweet' || notification.type === 'reply') {
    return isKeyringContact(mod, notification.actor_publicKey) || notification.type === 'reply' && isReplyToOwnTweet(mod, notification);
  }
  if (request === 'like tweet' || request === 'retweet' || notification.type === 'like' || notification.type === 'quote' || notification.type === 'retweet') {
    return isOwnTweetInteraction(mod, notification);
  }
  return false;
}
function aggregateLikeNotification(mod, existing, incoming) {
  existing.count = (existing.count || 1) + 1;
  existing.created_at = Math.max(existing.created_at || 0, incoming.created_at || 0);
  existing.time = mod.app.browser.formatRelativeTime(existing.created_at);
  existing.refreshActionText();
  resortNotificationTimeline(mod);
  return existing;
}
function addNotification(mod, input) {
  var notification = normalizeNotificationInput(mod, input);
  if (!notification || !notification.signature || !notification.tweet_signature) {
    return null;
  }
  if (!shouldNotify(mod, notification)) {
    return null;
  }
  ensureNotificationTweet(mod, notification);
  if (!Tweets.hasTweet(mod, notification.tweet_signature)) {
    return null;
  }
  if (hasNotification(mod, notification.signature)) {
    return updateNotification(mod, input);
  }
  var aggregateKey = getNotificationAggregateKey(mod, notification);
  if (aggregateKey && mod.notifications_aggregate[aggregateKey]) {
    var existing = getNotification(mod, mod.notifications_aggregate[aggregateKey]);
    if (existing) {
      return aggregateLikeNotification(mod, existing, notification);
    }
  }
  mod.notifications[notification.signature] = notification;
  insertNotificationTimeline(mod, notification.signature);
  if (aggregateKey) {
    mod.notifications_aggregate[aggregateKey] = notification.signature;
  }
  incrementUnreadNotifications(mod, notification);
  updateNotificationBadge(mod);
  return notification;
}
function removeNotification(mod, signature) {
  if (!signature || !hasNotification(mod, signature)) {
    return false;
  }
  var notification = getNotification(mod, signature);
  var aggregateKey = getNotificationAggregateKey(mod, notification);
  if (aggregateKey && mod.notifications_aggregate[aggregateKey] === signature) {
    delete mod.notifications_aggregate[aggregateKey];
  }
  if (notification !== null && notification !== void 0 && notification.unread) {
    mod.notifications_unread_count = Math.max(0, mod.notifications_unread_count - 1);
    updateNotificationBadge(mod);
  }
  removeFromNotificationTimeline(mod, signature);
  delete mod.notifications[signature];
  return true;
}
function updateNotification(mod, input) {
  var _Tweets$getTweet2;
  var notification = normalizeNotificationInput(mod, input);
  if (!notification || !notification.signature) {
    return null;
  }
  var existing = getNotification(mod, notification.signature);
  if (!existing) {
    return addNotification(mod, input);
  }
  existing.parseFromData({
    signature: notification.signature,
    tweet_signature: notification.tweet_signature,
    type: notification.type,
    actor_publicKey: notification.actor_publicKey,
    actor_name: notification.actor_name,
    actor_avatar: notification.actor_avatar,
    text: notification.text,
    count: notification.count,
    created_at: notification.created_at,
    time: notification.time,
    unread: existing.unread
  });
  if (notification.tx) {
    existing.tx = notification.tx;
  }
  if (!((_Tweets$getTweet2 = Tweets.getTweet(mod, existing.tweet_signature)) !== null && _Tweets$getTweet2 !== void 0 && _Tweets$getTweet2.ephemeral)) {
    existing.refreshActionText();
  }
  resortNotificationTimeline(mod);
  return existing;
}
function getNotification(mod, signature) {
  if (!signature) {
    return null;
  }
  return mod.notifications[signature] || null;
}
function hasNotification(mod, signature) {
  return Boolean(signature && mod.notifications[signature]);
}
function insertNotificationTimeline(mod, signature) {
  var notification = getNotification(mod, signature);
  if (!notification) {
    return;
  }
  if (!mod.notifications_timeline.includes(signature)) {
    mod.notifications_timeline.push(signature);
  }
  resortNotificationTimeline(mod);
}
function removeFromNotificationTimeline(mod, signature) {
  mod.notifications_timeline = mod.notifications_timeline.filter(function (s) {
    return s !== signature;
  });
}
function resortNotificationTimeline(mod) {
  mod.notifications_timeline.sort(function (a, b) {
    var notificationA = getNotification(mod, a);
    var notificationB = getNotification(mod, b);
    return ((notificationB === null || notificationB === void 0 ? void 0 : notificationB.created_at) || 0) - ((notificationA === null || notificationA === void 0 ? void 0 : notificationA.created_at) || 0);
  });
}
module.exports = {
  normalizeNotificationInput: normalizeNotificationInput,
  getNotificationAggregateKey: getNotificationAggregateKey,
  getUnreadNotificationCount: getUnreadNotificationCount,
  incrementUnreadNotifications: incrementUnreadNotifications,
  markNotificationsViewed: markNotificationsViewed,
  updateNotificationBadge: updateNotificationBadge,
  ensureNotificationTweet: ensureNotificationTweet,
  isKeyringContact: isKeyringContact,
  getInteractionTargetPublicKey: getInteractionTargetPublicKey,
  isOwnTweetInteraction: isOwnTweetInteraction,
  isReplyToOwnTweet: isReplyToOwnTweet,
  shouldNotify: shouldNotify,
  aggregateLikeNotification: aggregateLikeNotification,
  addNotification: addNotification,
  removeNotification: removeNotification,
  updateNotification: updateNotification,
  getNotification: getNotification,
  hasNotification: hasNotification,
  insertNotificationTimeline: insertNotificationTimeline,
  removeFromNotificationTimeline: removeFromNotificationTimeline,
  resortNotificationTimeline: resortNotificationTimeline
};